/* cart-toast.js — Shared mobile ATC toast notification.
   window.showCartToast(addData) is called by gated drawer-open paths
   on mobile (≤749px) instead of opening the slideout drawer.
   addData is the /cart/add.js response — a single item object or
   { items: [...] } for multi-variant adds (blanks). */
(function () {
  var el, timer, styleInjected;

  /* ── Styles ─────────────────────────────────────────────────── */

  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    var s = document.createElement('style');
    s.id = 'atc-toast-css';
    s.textContent = [
      '.atc-toast{position:fixed;bottom:calc(env(safe-area-inset-bottom,0px) + 16px);left:12px;right:12px;z-index:2147483647;background:#fff;border-radius:18px;box-shadow:0 4px 24px rgba(0,0,0,.12);opacity:0;transform:translateY(20px);transition:opacity .2s ease,transform .2s ease;pointer-events:none;overflow:hidden;font-family:var(--font-stack-body-primary,system-ui,-apple-system,sans-serif);}',
      '.atc-toast.is-visible{opacity:1;transform:translateY(0);pointer-events:auto;}',
      '.atc-head{display:flex;align-items:center;gap:8px;background:#cffca6;padding:10px 12px 10px 14px;}',
      '.atc-check{width:20px;height:20px;border-radius:50%;background:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
      '.atc-check svg{width:12px;height:12px;}',
      '.atc-head__label{font-size:14px;font-weight:700;color:#098605;line-height:1;}',
      '.atc-close{margin-left:auto;background:none;border:none;padding:4px;cursor:pointer;color:#098605;display:flex;align-items:center;justify-content:center;flex-shrink:0;opacity:.7;}',
      '.atc-close:hover{opacity:1;}',
      '.atc-close svg{width:16px;height:16px;}',
      '.atc-body{padding:13px 16px 16px;}',
      '.atc-name{font-size:14px;font-weight:700;color:var(--color-text-main,#000);line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.atc-meta{display:flex;justify-content:space-between;align-items:baseline;margin-top:4px;}',
      '.atc-variant{font-size:13px;color:var(--color-secondary-text-main,rgba(0,0,0,.6));line-height:1.3;}',
      '.atc-price{font-size:14px;font-weight:700;color:var(--color-text-main,#000);line-height:1.3;white-space:nowrap;}',
      '.atc-cta{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:12px;padding:12px 0;background:#3eaeff;border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;text-decoration:none;text-align:center;transition:background .15s ease;}',
      '.atc-cta:hover{background:#0180c2;}',
      '.atc-cta svg{width:14px;height:14px;flex-shrink:0;}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ── Normalize add response ─────────────────────────────────── */

  function normalizeAdd(addData) {
    if (!addData) return null;

    /* Blanks paths (sites 1+4) wrap as { cartResponse, addedIds }.
       Standard paths (sites 2+3) pass a single line-item object. */
    var addedIds = null;
    var items;

    if (addData.cartResponse && addData.addedIds) {
      addedIds = addData.addedIds;
      var cart = addData.cartResponse;
      var allItems = Array.isArray(cart.items) ? cart.items : [];
      items = [];
      for (var i = 0; i < allItems.length; i++) {
        if (addedIds.hasOwnProperty(String(allItems[i].variant_id))) {
          items.push(allItems[i]);
        }
      }
    } else if (Array.isArray(addData.items)) {
      items = addData.items;
    } else if (Array.isArray(addData)) {
      items = addData;
    } else if (addData.id) {
      items = [addData];
    } else {
      return null;
    }
    if (!items.length) return null;

    var title = items[0].product_title || items[0].title || '';
    var rawVariant = items[0].variant_title || '';
    var variant = rawVariant.indexOf(' / ') !== -1
      ? rawVariant.split(' / ')[0]
      : rawVariant;
    if (variant) variant = variant.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });

    var totalQty = 0;
    var totalPrice = 0;
    for (var i = 0; i < items.length; i++) {
      var vid = String(items[i].variant_id);
      var submittedQty = addedIds ? (addedIds[vid] || items[i].quantity || 1) : (items[i].quantity || 1);
      var lineQty = items[i].quantity || 1;
      totalQty += submittedQty;
      var linePrice = items[i].final_line_price || items[i].line_price || items[i].price || 0;
      totalPrice += addedIds && lineQty > 0 ? Math.round(linePrice * submittedQty / lineQty) : linePrice;
    }
    return { title: title, variant: variant, qty: totalQty, price: totalPrice };
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var fmt = (typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.shop_money_format) || '${{amount}}';
    var dollars = (cents / 100).toFixed(2);
    var result = fmt
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount}}', dollars);
    return result.replace(/<[^>]*>/g, '');
  }

  /* ── DOM construction ───────────────────────────────────────── */

  function getEl() {
    if (el && el.parentNode) return el;
    injectStyles();
    el = document.createElement('div');
    el.className = 'atc-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    el.innerHTML =
      '<div class="atc-head">' +
        '<span class="atc-check">' +
          '<svg viewBox="0 0 12 12" fill="none"><path d="M2.5 6.5L5 9l4.5-5" stroke="#098605" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="atc-head__label">Added to cart</span>' +
        '<button type="button" class="atc-close" aria-label="Dismiss">' +
          '<svg viewBox="0 0 16 16" fill="none"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="atc-body">' +
        '<div class="atc-name"></div>' +
        '<div class="atc-meta">' +
          '<span class="atc-variant"></span>' +
          '<span class="atc-price"></span>' +
        '</div>' +
        '<a href="/cart" class="atc-cta">' +
          'View cart' +
          '<svg viewBox="0 0 14 14" fill="none"><path d="M1 7h12m0 0L8.5 2.5M13 7l-4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>' +
      '</div>';

    el.querySelector('.atc-close').addEventListener('click', function (e) {
      e.stopPropagation();
      hide();
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest('.atc-cta')) return;
      hide();
    });
    el.addEventListener('touchstart', pauseTimer, { passive: true });
    el.addEventListener('mouseenter', pauseTimer);
    el.addEventListener('touchend', resumeTimer, { passive: true });
    el.addEventListener('mouseleave', resumeTimer);
    document.body.appendChild(el);
    return el;
  }

  /* ── Timer / visibility ─────────────────────────────────────── */

  function pauseTimer() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  function resumeTimer() {
    if (!el || !el.classList.contains('is-visible')) return;
    timer = setTimeout(hide, 5000);
  }

  function hide() {
    if (!el) return;
    el.classList.remove('is-visible');
    if (timer) { clearTimeout(timer); timer = null; }
  }

  /* ── Public API ─────────────────────────────────────────────── */

  window.showCartToast = function (addData) {
    var data = normalizeAdd(addData);
    if (!data) return;

    var t = getEl();
    var nameEl = t.querySelector('.atc-name');
    var variantEl = t.querySelector('.atc-variant');
    var priceEl = t.querySelector('.atc-price');

    nameEl.textContent = data.title;
    var variantParts = [];
    if (data.variant) variantParts.push(data.variant);
    variantParts.push(data.qty + ' item' + (data.qty === 1 ? '' : 's'));
    variantEl.textContent = variantParts.join(' · ');
    priceEl.textContent = formatMoney(data.price);

    t.classList.remove('is-visible');
    void t.offsetWidth;
    t.classList.add('is-visible');
    if (timer) clearTimeout(timer);
    timer = setTimeout(hide, 5000);
  };
})();
